import React from 'react';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Box } from '@televet/kibble-ui/build/chakra';

interface ConversationCardBodyProps {
  messageContent?: string | null;
}

const ConversationCardBody = ({ messageContent }: ConversationCardBodyProps): JSX.Element => {
  return (
    <>
      {messageContent && (
        <Box className="Board__Card-ConversationDetails" mb={2} mx={3}>
          <Text size="md">{messageContent}</Text>
        </Box>
      )}
    </>
  );
};

export default ConversationCardBody;
